import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { accountingNumberFormatter } from "@common/helpers/number";
import { MoneyDirection } from "@common/constants";
import { useGlobalTransactionViewDrawer } from "@components/transactions/TransactionViewDrawer/useGlobalTransactionViewDrawer";
import classNames from "classnames";
import { ChartOfAccountsRow, SUBTYPE_TO_SWAP_DIRECTIONS } from "../utils";
import styles from "../styles.module.scss";

export const CreditCell = memo(
    ({ row }: CellContext<ViewTableFeatures, ChartOfAccountsRow, number>) => {
        const rowData = row.original;
        const openGlobalTransactionViewDrawer =
            useGlobalTransactionViewDrawer();

        // Classification row - no credit
        if (rowData.classification) {
            return <ViewTableCell />;
        }

        if (rowData.group) {
            return (
                <ViewTableCell>
                    <div className={styles.columnContent}>
                        {accountingNumberFormatter(rowData.groupCredit ?? 0)}
                    </div>
                </ViewTableCell>
            );
        }

        // Account row
        if (rowData.account && rowData.entityIds && rowData.accountIds) {
            const creditDirection = SUBTYPE_TO_SWAP_DIRECTIONS.includes(
                rowData.account.subtype,
            )
                ? MoneyDirection.MONEY_OUT
                : MoneyDirection.MONEY_IN;

            return (
                <ViewTableCell>
                    <div
                        className={classNames(styles.columnContent, {
                            [styles.creditColumn]: rowData.account.credit,
                        })}
                        onClick={() => {
                            if (!rowData.account?.credit) {
                                return;
                            }

                            openGlobalTransactionViewDrawer({
                                coaAccounts: rowData.accountIds,
                                entityIds: rowData.entityIds,
                                direction: creditDirection,
                            });
                        }}
                    >
                        {accountingNumberFormatter(rowData.account.credit)}
                    </div>
                </ViewTableCell>
            );
        }

        return <ViewTableCell />;
    },
);
